import React, { useEffect, useState } from "react";
import { GiSpotedFlower, GiLotus } from "react-icons/gi";
import { motion } from "framer-motion";

const FlowerRain = () => {
  const [flowers, setFlowers] = useState([]);

  useEffect(() => {
    // Create initial flowers
    const initialFlowers = Array.from({ length: 15 }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      delay: Math.random() * 5,
      size: `${Math.random() * 2 + 0.5}rem`, // 0.5rem to 2.5rem
      duration: 15 + Math.random() * 30, // Slower duration
      icon: Math.random() > 0.5 ? GiSpotedFlower : GiLotus,
      opacity: 0.2 + Math.random() * 0.5,
      zIndex: Math.random() > 0.7 ? 10 : 0,
    }));
    setFlowers(initialFlowers);

    // Add new flowers periodically at slower interval
    const interval = setInterval(() => {
      setFlowers(prev => [
        ...prev.slice(-25), // Keep max 25 flowers
        {
          id: Date.now(),
          left: `${Math.random() * 100}%`,
          delay: 0,
          size: `${Math.random() * 2 + 0.5}rem`,
          duration: 15 + Math.random() * 30, // Slower duration
          icon: Math.random() > 0.5 ? GiSpotedFlower : GiLotus,
          opacity: 0.2 + Math.random() * 0.5,
          zIndex: Math.random() > 0.7 ? 10 : 0,
        }
      ]);
    }, 1000); // Slower generation (1 second)

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-10 overflow-hidden">
      {flowers.map(flower => {
        const Icon = flower.icon;
        return (
          <motion.div
            key={flower.id}
            className="absolute"
            style={{
              zIndex: flower.zIndex,
              fontSize: flower.size,
              color: flower.icon === GiSpotedFlower ? 
                `rgba(236, 72, 153, ${flower.opacity})` : 
                `rgba(168, 85, 247, ${flower.opacity})`,
            }}
            initial={{
              top: '-10%',
              left: flower.left,
              opacity: 0,
            }}
            animate={{
              top: '110%',
              opacity: [0, flower.opacity, flower.opacity, 0],
              rotate: Math.random() > 0.5 ? 
                [0, 45 + Math.random() * 90] : 
                [0, -45 - Math.random() * 90],
            }}
            transition={{
              duration: flower.duration,
              delay: flower.delay,
              repeat: Infinity,
              ease: "linear",
            }}
          >
            <Icon />
          </motion.div>
        );
      })}
    </div>
  );
};

export default FlowerRain;